import { render, staticRenderFns } from "./SettingsNavLink.vue?vue&type=template&id=64a16f2b"
import script from "./SettingsNavLink.vue?vue&type=script&lang=ts"
export * from "./SettingsNavLink.vue?vue&type=script&lang=ts"
import style0 from "./SettingsNavLink.vue?vue&type=style&index=0&id=64a16f2b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports